import { Card, Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../app/stores/store'
import { history } from '../../..'
import FooterNew from '../Footer'

function FailedNew() {
  const { id } = useParams()
  const { paymentStore } = useStore()
  const { t } = useTranslation()

  const handleCancelButton = () => {
    history.push('/auctions')
  }

  useEffect(() => {
    if (id) {
      paymentStore.orderById(id)
    }
  }, [id, paymentStore])

  const handleNextButtonClick = () => {
    if (paymentStore.selectedPayments) {
      const { hash } = paymentStore.selectedPayments
      const url = `https://hi-private-crosslab.payrexx.com/en/?payment=${hash}`
      window.location.href = url
    }
  }

  return (
    <>
      <Container fluid className='card-center card-background'>
        <Card style={{ width: '874px' }} className='newFont prevent-select card-shadow'>
          <Card.Header>
            <p className='login-card-title'>{t('payment_status')}</p>
          </Card.Header>
          <Card.Body className='card-padding font-status-size'>
            <div className='d-flex'>
              <i
                style={{ fontSize: '60px' }}
                className='fa-regular text-danger fa-circle-xmark pe-3'
              />
              <h4 className='mt-2 fw-bolder text-black font-status-title-size'>{t('failed')}</h4>
            </div>
            <p className='text-black pt-4'>{t('payment_voided')}</p>
            <div className='payment-buttons'>
              <button onClick={handleCancelButton} className='text-white payment-button-cancel'>
                {t('cancel')}
              </button>
              <button
                onClick={handleNextButtonClick}
                className='text-white payment-button-tryagain'
              >
                {t('try_again')}
              </button>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <FooterNew />
    </>
  )
}
export default FailedNew
